import React, { forwardRef } from 'react';

import { IMaskInput } from 'react-imask';

type PhoneMaskInputProps = {
  name: string;
  value?: string | number;
  onChange: (event: { target: { name: string; value: string } }) => void;
};

const getLocalPhoneDigits = (value: string | number | undefined): string => {
  const digits = String(value ?? '').replace(/\D/g, '');

  if (!digits) return '';

  if (digits.startsWith('380')) return digits.slice(3, 12);
  if (digits.startsWith('80')) return digits.slice(2, 11);
  if (digits.startsWith('0')) return digits.slice(1, 10);

  return digits.slice(0, 9);
};

export const PhoneMaskInput = forwardRef<HTMLInputElement, PhoneMaskInputProps>(
  function PhoneMaskInput({ name, onChange, value, ...other }, ref) {
    const uiValue = getLocalPhoneDigits(value);

    return (
      <IMaskInput
        {...other}
        mask="+38 (\0A0) 000-00-00"
        definitions={{
          A: /[35679]/,
          0: /\d/,
        }}
        value={uiValue}
        unmask={true}
        lazy={false}
        overwrite
        inputRef={ref as any}
        prepare={(input) => {
          const digits = String(input).replace(/\D/g, '');

          // Обычный ввод по одной цифре не трогаем
          if (digits.length <= 1) return input;

          // Paste / autofill нормализуем
          return getLocalPhoneDigits(input);
        }}
        onAccept={(raw) => {
          const local9 = getLocalPhoneDigits(raw);
          const full = local9 ? `380${local9}` : '';

          onChange({ target: { name, value: full } });
        }}
      />
    );
  },
);
